/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal } from "antd";
import { useSelector } from "react-redux";
import { State } from "../../../../model/application/state";

export const RegistrationAlert = () => {

  const { merchantsRegistrationState }: any = useSelector((state) => state);
  const state: State.RegistrationPage = merchantsRegistrationState;

  return (
    <>
      <Modal
        centered
        open={state.showAlert}
        onCancel={() => {window.location.href = "/dashboard"}}
        footer={null}
        width={450}
        closable={false}
      >
        <div style={{textAlign: 'center', marginTop: 20}}>
          <p style={{ textAlign: "center" }}>
            Thank you for your time, kindly click on okay to continue.
          </p>
          <Button
            style={{
              backgroundColor: "#2B872B",
              color: "white",
              borderRadius: 5,
            }}
            onClick={() => {window.location.href = "/dashboard"}}
            className="mt-5"
          >
            Okay
          </Button>
        </div>
      </Modal>
    </>
  );
};
